module.exports = __webpack_public_path__ + "media/images/top/feature03-ca3384c7b1e6ea55304b6758ba16f758.jpg";